import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=0b4f4a52"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=0b4f4a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports